import { buildPath } from "../../../helpers/string";
import { root } from "./root";

export const dashboard = {
  path: "dashboard",
  getLink: () => buildPath([root.path, dashboard.path]),
  permissions: [],
};
